import { useMemoAsync } from "@opendash/core";
import Parse from "parse";
import { useMemo, useState } from "react";
import { Kanban_State } from "../../../../js/parsegenerated";

export const useKanbanStates = () => {
  const [loading, setLoading] = useState(true);
  const states = useMemoAsync(
    async () => {
      setLoading(true);
      const fetchedStates = await new Parse.Query(Kanban_State)
        .ascending("order")
        .equalTo("enabled", true)
        .find();
      setLoading(false);

      return fetchedStates;
    },
    [],
    []
  );

  const { inbox, outbox } = useMemo(
    () => ({
      inbox: states?.find((state) => state.get("isInbox")),
      outbox: states?.find((state) => state.get("isFinished")),
    }),
    [states]
  );

  return { states, loading, inbox, outbox };
};
